import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { PuzzleService } from "../services/PuzzleService";

const styles: string = css`
:host {
    display: block;
    margin: auto;
}

.puzzel {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 5px;
    padding: 10px;
    background: #a0a0a0;
    border-radius: 10px;
}

.puzzel_img {
    display: contents;
}

.puzzel_img img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 5px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    background: linear-gradient(to bottom, #d1d1d1, #8c8c8c);
    padding: 5px;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

.puzzel_img img.selected {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px rgba(0, 255, 0, 0.7);
}

button {
    margin-top: 10px;
    padding: 8px 15px;
    background: #ff4747;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

button:hover {
    background: #d63b3b;
}
`;

export class PuzzelComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();
    private _puzzleService: PuzzleService = new PuzzleService();
    private selectedImages: Set<string> = new Set();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
        this.addEventListeners();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const element: HTMLElement = this.renderPuzzel();
        this.shadowRoot.firstChild?.remove();
        this.shadowRoot.append(element);
    }

    private renderPuzzel(): HTMLElement {
        const element: HTMLElement = html`
            <div>
                <style>${styles}</style>
                <div>
                    <div class="puzzel">
                        <div class="puzzel_img">
                            <img src="../assets/img/rooms/1.png" id="1">
                            <img src="../assets/img/rooms/2.png" id="2">
                            <img src="../assets/img/rooms/3.png" id="3">
                            <img src="../assets/img/rooms/4.png" id="4">
                            <img src="../assets/img/rooms/5.png" id="5">
                            <img src="../assets/img/rooms/6.png" id="6">
                            <img src="../assets/img/rooms/7.png" id="7">
                            <img src="../assets/img/rooms/8.png" id="8">
                            <img src="../assets/img/rooms/9.png" id="9">
                        </div>
                        <button id="closeBtn">Close</button>
                    </div>
                </div>
            </div>
        `;
        return element;
    }

    private addEventListeners(): void {
        if (!this.shadowRoot) return;

        const images: NodeListOf<HTMLImageElement> = this.shadowRoot.querySelectorAll(".puzzel_img img");
        images.forEach(img => {
            img.addEventListener("click", event => this.handleImageClick(event));
        });

        const closeButton: HTMLButtonElement | null = this.shadowRoot.querySelector("#closeBtn");
        if (closeButton) {
            closeButton.addEventListener("click", () => this._gameEventService.switchPage(Page.Canvas));
        }
    }

    private handleImageClick(event: Event): void {
        const target: HTMLElement = event.target as HTMLImageElement;
        if (!target.id) return;

        if (this.selectedImages.has(target.id)) {
            this.selectedImages.delete(target.id);
            target.classList.remove("selected");
        }
        else {
            if (this.selectedImages.size >= 3) {
                return;
            }
            this.selectedImages.add(target.id);
            target.classList.add("selected");

            if (this.selectedImages.size === 3) {
                void this.checkSolution().catch((error: unknown) => {
                    console.error("Error in checkSolution:", error);
                });
            }
        }
    }

    private async checkSolution(): Promise<void> {
        const selectedArray: string[] = Array.from(this.selectedImages).sort();
        const code: string = selectedArray.join("");

        console.log("Sending code to backend:", code); // Log the request

        try {
            const response: boolean = await this._puzzleService.checkPuzzle(code);

            console.log("Response from backend:", response); // Log the response

            if (response) {
                alert("Puzzle Solved!");
                location.reload();
            }
            else {
                alert("Try Again!");
            }
        }
        catch (error) {
            console.error("Error checking puzzle:", error);
            alert("Error checking puzzle. Try again.");
        }

        this.selectedImages.clear();
        const images: NodeListOf<HTMLImageElement> | undefined = this.shadowRoot?.querySelectorAll(".puzzel_img img");
        images?.forEach(img => img.classList.remove("selected"));
    }
}
